import React from 'react';
import InputV1 from '../../../../../components/ComponentsV1/InputV1';

const CategoryDropdown = ({
  categoriesLoading,
  options,
  value,
  onChange,
}) => {
  return (
    <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-1'>
      <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
        Category
      </div>
      <div className='tw-flex tw-flex-col tw-w-full' style={{ width: '100%' }}>
        <InputV1
          loading={categoriesLoading}
          options={options || []}
          placeholder='Choose category'
          multiple={false}
          isSearchable
          inputProps={{
            className: 'tw-border-none',
            type: 'text',
            style: { width: '100%' },
          }}
          style={{ width: '100%', display: 'block' }}
          closeOnSelect
          onSelect={(selectedValue) => {
            onChange(String(selectedValue?.label ?? ''));
          }}
          value={value}
        />
      </div>
    </div>
  );
};

export default CategoryDropdown;